import { ComponentPropsWithoutRef, MouseEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import TextInput from "components/ui/TextInput";
import styles from "./index.module.scss";

type Props = Omit<ComponentPropsWithoutRef<typeof TextInput>, "type" | "trailing">;

/**
 * Password field with a reveal toggle. The toggle stays out of the tab order:
 * it is a convenience for pointer users, and tabbing from the field should
 * reach the submit button rather than a display control.
 */
export default function PasswordInput(props: Props) {
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();

  const keepFocusInField = (evt: MouseEvent<HTMLButtonElement>) => {
    evt.preventDefault();
  };

  return (
    <TextInput
      {...props}
      type={showPassword ? "text" : "password"}
      trailing={
        <button
          type="button"
          className={styles.toggle}
          disabled={props.disabled}
          tabIndex={-1}
          aria-pressed={showPassword}
          aria-label={t("Common.passwordInput.toggleVisibility")}
          onClick={() => setShowPassword(shown => !shown)}
          onMouseDown={keepFocusInField}
        >
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </button>
      }
    />
  );
}
